import React from 'react'
import { createMuiTheme, ThemeProvider } from '@material-ui/core'

const theme = createMuiTheme(
	/**
   * @see https://material-ui.com/customization/themes/#theme-configuration-variables
   */
	{
		// direction: "rtl",
		typography: {
			fontSize: 16,
			fontFamily: ['Arial', 'sans-serif'].join(',')
		},

		/* CAMBIAR COLOR — paleta Comarca Cinco Villas */
		palette: {
			primary: {
				main: '#4f5248',
			},
			secondary: {
				main: '#e85d1c',
			},
			error: {
				main: '#F64E60',
			}
		},

		/**
     * @see https://material-ui.com/customization/globals/#default-props
     */
		props: {
			// Name of the component ⚛️
			MuiButtonBase: {
				// The properties to apply
				disableRipple: false // No more ripple, on the whole application 💣!
			},

			// Set default elevation to 1 for popovers.
			MuiPopover: {
				elevation: 1
			}
		}
	}
)

export function MaterialThemeProvider(props) {
	const { children } = props

	return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}
